import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Link } from "@mui/material";
import Box from "components/common/Box";

export default function DialogVhiecles({ open, closeVehicles }) {
  return (
    <>
      <Dialog
        open={open}
        onClose={closeVehicles}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "0px",
          }}
        >
          <img
            style={{ height: "65px" }}
            src="../images/successful.svg"
            alt="logo"
          />
        </DialogContent>
        <DialogContent sx={{ padding: "30px 60px" }}>
          <DialogTitle
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#1A1A1A",
              padding: "0px 10px",
            }}
          >
            Vehicles added
          </DialogTitle>
          <DialogTitle
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#1A1A1A",
              padding: "0px 20px",
            }}
          >
            successfully.
          </DialogTitle>
        </DialogContent>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
         
            <Button
              variant="contained"
              sx={{
                background: "#04AAD",
                marginRight: "1rem",
                width: "100.17px",
                height: "40px",
                marginBottom: "1.2rem",
                cursor: "pointer",
                width: "200px",
              }}
              onClick={closeVehicles}
            >
              ok
            </Button>
        
        </Box>
      </Dialog>
    </>
  );
}
